import { Address, GetInvoiceHistoryPayload, StreamOnProduct, UserDetails } from '@mfe/shared/schema-types';

import { SetErrorActionPayload } from './streamOnPromoSlice';

export type StreamOnPromoState = {
  streamEligibility: {
    error: SetErrorActionPayload;
    isEligible: boolean | null;
  };
  confirmModal: boolean;
  currentMonthlyBill: GetInvoiceHistoryPayload & { loading: boolean | null };
  currentPage: string;
  didOrderFail: {
    didOrderFail: boolean;
    failureReason: string | null;
  };
  didOrderSucceed: boolean;
  editAddress: Address;
  isEditingAddress: boolean;
  isLoading: boolean;
  isOrderSubmitting: boolean;
  isScrubbingLoading: boolean;
  offerDetails: StreamOnProduct & { loading: boolean | null };
  orderAttempts: number;
  persona: Persona;
  phoneNumber: string;
  shippingAddress: Address;
  scrubLocation: Address | null;
  userDetails: UserDetails;
  isEditingNumber: boolean;
  configureStreamSuccess: boolean;
  configureStreamError: SetErrorActionPayload;
  configureStreamLoading: boolean;
  configureStream: ConfigureStream;
};

export type ConfigureStream = {
  productTypeId: string;
  rootProductTypeId: string;
  shoppingCartId: string;
};

export enum Pages {
  login = '/',
  productDetails = '/productDetails',
  orderSummary = '/orderSummary',
  orderReview = '/orderReview',
  error = '/error',
  unavailable = '/unavailable',
  None = 'none',
}

export enum Persona {
  CUSTOMER = 'buy-mv',
  CARE_AGENT = 'buy-gac',
  PARTNER = 'buy-gpp',
}

export const resetOrderAttempts = 0;
